import { useState } from 'react';
import { TextSpan } from '../../../Atoms/Text';
import { TextButton } from '../../../Atoms/TextButton';
import { productCategoryLabel } from '../../../../constants/advise';

// A large Salesforce supplier lists 30 Products or more, which would make its row many lines tall.
const SHOWN = 3;

/** A supplier's categories: the first few, and a link that shows the rest in place. */
export const SupplierCategoriesCell = ({ categories }: { categories: string[] }) => {
  const [expanded, setExpanded] = useState(false);
  const hidden = categories.length - SHOWN;
  const shown = expanded || hidden <= 0 ? categories : categories.slice(0, SHOWN);

  return (
    <TextSpan
      size="sm"
      color="grey6">
      {shown.map(productCategoryLabel).join(', ')}
      {hidden > 0 && (
        <TextButton
          className="ml-1.5"
          onClick={() => setExpanded(!expanded)}>
          {expanded ? 'Show less' : `+${hidden} more`}
        </TextButton>
      )}
    </TextSpan>
  );
};
